import React from "react";
import { Link } from "react-router-dom";
import { usePlayer } from "../context/PlayerContext";
import { Bookmark, Trash2 } from "lucide-react";

export default function Saved() {
  const { saved, toggleSaved } = usePlayer();

  return (
    <div className="animate-fade-up" data-testid="page-saved">
      <div className="mb-8">
        <p className="label-caps text-gold/85">Your Library</p>
        <h1 className="font-display text-4xl lg:text-5xl text-paper mt-2">Saved Lectures</h1>
        <p className="text-white/60 mt-2">Bookmarks are kept in this browser for private, distraction-free study.</p>
      </div>

      {saved.length === 0 && (
        <div className="archival-card rounded-lg p-12 text-center" data-testid="saved-empty">
          <Bookmark className="w-6 h-6 text-gold mx-auto mb-3" />
          <p className="font-display text-2xl">Nothing saved yet</p>
          <p className="text-white/60 mt-2">Tap the bookmark on any lecture to add it here.</p>
          <Link to="/explore" className="btn-primary inline-block mt-6">Explore the archive</Link>
        </div>
      )}

      {saved.length > 0 && (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-testid="saved-list">
          {saved.map(s => (
            <div key={s.id} className="archival-card rounded-lg p-4 flex items-center gap-4" data-testid={`saved-row-${s.id}`}>
              <Link to={`/item/${encodeURIComponent(s.id)}`} className="shrink-0">
                <div className="w-[72px] h-[72px] rounded-md overflow-hidden bg-black/40 border border-white/5">
                  <img src={s.thumbnail} alt="" className="w-full h-full object-contain" />
                </div>
              </Link>
              <div className="min-w-0 flex-1">
                <Link to={`/item/${encodeURIComponent(s.id)}`} className="block">
                  <h3 className="font-display text-lg text-paper truncate hover:text-emerald-soft">{s.title}</h3>
                </Link>
                <p className="text-sm text-white/55 truncate">{s.creator}</p>
              </div>
              <button
                onClick={() => toggleSaved(s)}
                className="chip"
                aria-label="Remove"
                data-testid={`saved-remove-${s.id}`}
              >
                <Trash2 className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
